import { ExaminerFunction } from '../../pages/Assessment/Assessment.types';

export interface IComment {
  commentId: string;
  examinerId: string;
  examinerFirstName: string;
  examinerLastName: string;
  examinerFunction: ExaminerFunction | null;
  commentTypeId: CommentTypeId;
  criterionName?: string;
  criterionPoints?: number | null;
  history: IHistoryCommment[] | null;
  content: string;
  x: null | number;
  y: null | number;
  pageNumber: number | null;
  partialScoreId?: string | null;
  createDate?: string;
}

export interface IHistoryCommment {
  commentId: string;
  content: string;
  examinerId?: string;
  examinerFirstName?: string;
  examinerLastName?: string;
  examinerFunction?: ExaminerFunction | null;
  criterionPoints: number;
}

export interface IComments {
  comments: IComment[];
}

export enum CommentTypeId {
  OFFPAGE,
  ONIMAGE,
  ONCRITERIA,
}
